import { Icon } from "@mindlercare/ui-web";
import { useTranslation } from "react-i18next";
import { styled } from "styled-components";
import { Typography } from "components/typography";

interface Props {
  patientNoteCount?: number;
  questionnairesInProgramAnswered?: number;
  totalQuestionnairesInProgram?: number;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;

  & svg {
    color: ${(props) => props.theme.COLORS.GRAY};
    width: 20px;
  }
`;

// A program defines at least one patient note (the legacy reflection). With
// multi-note programs a request can have several notes, but the table data does
// not carry the per-program note-block count, so we use the number of notes the
// patient has actually written as the denominator floor. This keeps the display
// honest ("1 of 1", "2 of 2") and never shows the impossible "2 of 1".
// TODO: source the true number of notes a program defines from a per-program
// count endpoint (mirroring indianapolis/questionnaire-counts) for an accurate
// "answered of total" denominator.
const MIN_PATIENT_NOTE_COUNT = 1;

export const PatientNotesCellText = ({
  patientNoteCount,
  questionnairesInProgramAnswered,
  totalQuestionnairesInProgram,
}: Props) => {
  const { t } = useTranslation();

  const totalPatientNotes = Math.max(
    MIN_PATIENT_NOTE_COUNT,
    patientNoteCount ?? 0,
  );

  return (
    <Wrapper>
      <Icon.Notes />
      <Typography insensitive variant="body-small" color="GRAY_BLACK">
        {t("PATIENT_NOTES_X_OF_Y", {
          count:
            (patientNoteCount ?? 0) + (questionnairesInProgramAnswered ?? 0),
          total: totalPatientNotes + (totalQuestionnairesInProgram ?? 0),
        })}
      </Typography>
    </Wrapper>
  );
};
